export default {
      id: "uploadfile-usage",
      viewBox: "-58 1 511 512",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#uploadfile",
      toString: function () {
        return this.url;
      }
    }